var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/contactus/solid/icon-telegram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222222",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,2 C22.1796833,2 28,7.82031667 28,15 L27.9964495,15.3068554 C27.8334278,22.3447903 22.0771164,28 15,28 L14.6931446,27.9964495 C7.65520972,27.8334278 2,22.0771164 2,15 L2.00355045,14.6931446 C2.16657218,7.65520972 7.92288357,2 15,2 Z M21.1993967,10.4537375 C21.3121717,9.17627083 19.9595217,9.7023375 19.9595217,9.7023375 C19.9595217,9.7023375 19.0025802,10.0949198 18.0210991,10.5015204 L17.6537145,10.6539133 C17.0455601,10.9065321 16.4733473,11.1461423 16.1647133,11.2803208 L7.410405,14.8872792 C6.03495857,15.4240128 6.60647218,15.9307786 6.74472894,16.0332098 L6.77167167,16.0519708 C6.77167167,16.0519708 7.72180131,16.377734 8.69902049,16.6831703 L9.04354319,16.7895638 L9.21383,16.8410708 C10.3410383,17.1791792 10.94218,16.8034792 10.94218,16.8034792 L16.2398967,13.2341125 C18.118505,11.9566458 17.6676217,13.0086708 17.2167383,13.4595542 C16.2398967,14.4363958 14.6243217,15.9768958 13.2716717,17.2167708 C12.67053,17.7427292 12.9710467,18.1936125 13.23408,18.4190542 C14.21103,19.2456375 16.87863,20.9363958 17.0288883,21.0491708 C17.2167383,21.1994292 18.2687633,21.8757542 18.9074967,21.7253875 C19.54623,21.5751292 19.6214133,20.7109542 19.6214133,20.7109542 L20.5606633,14.8120958 C20.8612883,12.8208208 21.161805,10.9798042 21.1993967,10.4537375 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.4%",
    y: "-7.7%",
    width: "130.8%",
    height: "130.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/contactus/solid/icon-telegram",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.3f9cb1815267b65d286bb483d1b7551d.svg";
export { ForwardRef as ReactComponent };